import allReplicas, { replicasWIP } from "assets/replicas";
import { checkIsNew, sortReplicasByDate } from "utils";

import ReplicaItem from "components/Replicas/ReplicaItem";
import styled from "styled-components";

const Replicas = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, 18%);
  justify-content: center;
  gap: 12px;
  place-items: center;

  ${(props) => props.theme.breakpoints.L} {
    grid-template-columns: repeat(auto-fit, max(225px, 23%));
  }
  ${(props) => props.theme.breakpoints.M} {
    grid-template-columns: repeat(auto-fit, 30%);
  }
  ${(props) => props.theme.breakpoints.SM} {
    grid-template-columns: repeat(auto-fit, 30%);
  }
  ${(props) => props.theme.breakpoints.S} {
    grid-template-columns: repeat(auto-fit, max(180px, 45%));
  }
  ${(props) => props.theme.breakpoints.XXS} {
    grid-template-columns: repeat(auto-fit, 50%);
  }
`;

const ReplicaList = (props: {
  renderItems?: () => React.ReactNode;
  selectedCategoryId?: string;
  newOnly?: boolean;
  wipOnly?: boolean;
  orderBy?: "date";
}) => {
  const getDisplayedReplicas = () => {
    if (props.wipOnly) {
      return [...replicasWIP];
    }

    let displayedReplicas = [...allReplicas];

    if (props.selectedCategoryId) {
      displayedReplicas = displayedReplicas.filter(
        (replica) => replica.category.id === props.selectedCategoryId,
      );
    }

    if (props.newOnly) {
      displayedReplicas = displayedReplicas.filter((replica) => {
        const latestVersion = replica.versions[0];
        const isNew = checkIsNew(latestVersion.datePublished);
        return isNew;
      });
    }

    if (props.orderBy === "date") {
      // then sort by dateCreated (in case multiple replicas are published on the same date, they should be sorted by dateCreated)
      displayedReplicas = sortReplicasByDate({ replicas: displayedReplicas });
    }

    return displayedReplicas;
  };

  return (
    <Replicas>
      {props.renderItems
        ? props.renderItems()
        : getDisplayedReplicas().map((replica, i) => (
            <ReplicaItem
              key={i}
              replica={replica} /* noLabel={props.newOnly} */
            />
          ))}
    </Replicas>
  );
};

export default ReplicaList;
